/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1PersonIdDeactivateMutationResponse,
  PatchApiV1PersonIdDeactivatePathParams,
  PatchApiV1PersonIdDeactivate401,
  PatchApiV1PersonIdDeactivate404,
  PatchApiV1PersonIdDeactivate500,
} from "../../types/personRegisterController/PatchApiV1PersonIdDeactivate.ts";

function getPatchApiV1PersonIdDeactivateUrl(
  id: PatchApiV1PersonIdDeactivatePathParams["id"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/person/${id}/deactivate` as const,
  };
  return res;
}

/**
 * @description Desativa uma pessoa (soft delete). **(Requer Authorization para autenticação)**
 * @summary Desativar pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/deactivate}
 */
export async function patchApiV1PersonIdDeactivate(
  id: PatchApiV1PersonIdDeactivatePathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1PersonIdDeactivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdDeactivate401
      | PatchApiV1PersonIdDeactivate404
      | PatchApiV1PersonIdDeactivate500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1PersonIdDeactivateUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
